module.exports = __webpack_public_path__ + "img/3-logo_footer_desktop.eb285c95.png";